import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertOtherDocumentLinkUI from './insertotherdocumentlinkui';

export default class InsertOtherDocumentLink extends Plugin {
  static get pluginName() {
    return 'InsertOtherDocumentLink';
  }

  static get requires() {
    return [ InsertOtherDocumentLinkUI ];
  }
}
